export const AnalyticsModuleUrls = {
    ANALYTICS: 'analytics',

    BUSINESS_OVERVIEW: 'overview',
    MONETIZATION: 'monetization',
    UA: 'user-acquisition',
    GAME_REPORT: 'game',
    MONETIZATION_WATCH: 'm-watch',
    REPORTS: 'reports',
    COHORT: 'cohorts',
    FUNNELS: 'funnels',
    INTERNAL: 'internal',
};
export const DashboardModuleUrls = {
    ANALYTICS: AnalyticsModuleUrls.ANALYTICS,
    DASHBOARD: 'dashboard',
    INTERNAL_DASHBOARD: 'internal',
    RETENTION_RATE: 'retention_rate',
    LTV: 'ltv',
};

export const AppsModuleUrls = {
    APPS: 'apps',
    CREATE: 'new',
    APP_ID: ':appId',
    UPDATE: ':appId/edit',
    LINKED_USER_ACCOUNTS: 'linked_networks',
    AD_NETWORK_MONITOR: 'ad_network_monitor/:appId',
    AD_UNIT_EDITOR_DEPRECATED_URL: ':appId/ad_units_editor',
    DCC: ':appId/dcc',
    APP_SETTINGS: ':appId/edit',
    APP_PLACEMENT: 'placements/:appId',
    ATTRIBUTION_SETTINGS: ':appId/attribution-settings',
    MMP_ACCOUNTS: 'mmp_accounts',
    APP_EVENTS: ':appId/events',
    EVENTS: 'events',
};

export const OnboardingModuleUrls = {
    ONBOARDING: 'onboarding',
    APP: 'app',
    MONETIZATION_SETUP: 'monetization_setup',
    PAYMENTS: 'payments',
    SDK_INTEGRATION: 'sdk_integration',
    PUBLISH_APP: 'publish_app',
};

export const MMPAccountsUrls = {
    CREATE: 'new',
    UPDATE: ':id/edit',
};

export const UserAcquisitionAccountsUrls = {
    CREATE: 'new',
    UPDATE: ':id/edit',
};

export const BidonInstanceUrls = {
    CREATE: 'new',
    UPDATE: 'edit',
};

export const DccModuleUrls = {
    LINE_ITEMS: 'line_items',
    CONFIGURATIONS: 'configurations',
    NEW_CONFIGURATION: 'new',
    EDIT_CONFIGURATION: ':configurationId/edit',
    // it's made on purpose to have different variable for resolvers
    COPY_CONFIGURATIONS: ':confId/copy',

    MEDIATION_GROUPS: 'mediation_groups',
    NEW_MEDIATION_GROUP: 'new',
    EDIT_MEDIATION_GROUP: ':mediationGroupId/edit',
    COPY_MEDIATION_GROUP: ':medId/copy',
};

export const PayoutsModuleUrls = {
    PAYOUTS: 'billing',
    REPORTS: 'reports',
    REQUESTS: 'requests',
    DETAILS: 'details/edit',
    NEW: 'new',
    HISTORY: 'history',
    AUTO_PAYOUTS: 'autopayouts',
    PUBLISHING: 'publishing',
};

export const SignUpModuleUrls = {
    SUCCESS: 'success',
};

export const BidManagerModuleUrls = {
    BID_MANAGER: 'bid_manager',
    CREATE_CREATIVE: 'create_creative',
    EDIT_CREATIVE: 'edit_creative/:id',
    CREATIVES: 'creatives',
    CREATE_CAMPAIGN: 'create_campaign',
    CAMPAIGNS: 'campaigns',
    ACCOUNTS: 'accounts',
    TARGET_CPA_CAMPAIGNS: 'target_cpa_campaigns',
};

export const CreativeLibraryModuleUrls = {
    CREATIVE_LIBRARY: 'creative-library',
    TEST_RESULTS: 'test-results',
    UPLOADS: 'uploads',
    CREATIVES: 'creatives',
    TEST_FLOW: 'test-flow',
    CREATE_TEST_FLOW: 'create-test-flow',
    EDIT_TEST_FLOW: 'edit-test-flow',
};

export const ExperimentsModuleUrls = {
    EXPERIMENTS: 'experiments',
    COLLECTION: 'collection',
    NEW: 'new',
    INFO: ':id',
    EDIT: ':id/edit',
};

export const IntegrationsModuleUrls = {
    INTEGRATIONS: 'integrations',
    MEDIATION_AD_NETWORKS: 'mediation_ad_networks',
    MEDIATIONS: 'mediations',
    USER_ACQUISITION: 'user_acquisition',
    ADD_UNITY_ACCOUNT: 'add_unity_account',
    EDIT_UNITY_ACCOUNT: 'edit_unity_account',
    ADD_APPGROWTH_ACCOUNT: 'add_appgrowth_account',
    EDIT_APPGROWTH_ACCOUNT: 'edit_appgrowth_account',
    BID_MANAGER: 'bid_manager',
    BIDON_INSTANCES: 'bidon_instances',
};

export const IframePagesModuleUrls = {
    NEW: 'new',
    EDIT: 'edit',
    SEGMENTS: 'segments',
    PLACEMENTS: 'placements?app_id=:appId',
    AD_SERVER: 'ad_server',
    AD_SERVER_CAMPAIGNS: 'campaigns',
    AD_SERVER_CREATIVE: 'creative_sets',
    CHANGELOG: 'changelog',
    CHANGELOGS: 'changelogs/adserver',
};

export const ProfilePagesModuleUrls = {
    EDIT: 'edit',
    PROFILE: 'profile',
    USER_PROFILE: 'user_profile',
    ACCOUNT: 'account',
    SECURITY: 'security',
    APP_ADS_TXT: 'app_ads_txt',
    ADS_TXT: 'ads_txt',
    API_CREDENTIALS: 'api_credentials',
};

export const AppUrls = {
    SIGN_IN: 'signin',
    SIGN_UP: 'signup',
    SIGN_UP_SUCCESS: `signup/${SignUpModuleUrls.SUCCESS}`,
    REMIND_PASSWORD: 'remind-password',
    SIGN_IN_BACK_TO: 'signin?back_to=:backTo',
    SIGN_OUT: 'signout',
    BRIDGE: 'auth-bridge',

    ANALYTICS: DashboardModuleUrls.ANALYTICS,
    ANALYTICS_REPORTS: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.REPORTS].join('/'),
    ANALYTICS_COHORTS: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.COHORT].join('/'),
    ANALYTICS_GAME_REPORT: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.GAME_REPORT].join('/'),
    MONETIZATION: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.MONETIZATION].join('/'),
    BUSINESS_OVERVIEW: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.BUSINESS_OVERVIEW].join('/'),
    ANALYTICS_FUNNELS: [AnalyticsModuleUrls.ANALYTICS, AnalyticsModuleUrls.FUNNELS].join('/'),
    DASHBOARD: DashboardModuleUrls.DASHBOARD,
    DASHBOARD_INTERNAL: [DashboardModuleUrls.ANALYTICS, DashboardModuleUrls.INTERNAL_DASHBOARD].join('/'),
    DASHBOARD_RETENTION_RATE: [DashboardModuleUrls.DASHBOARD, DashboardModuleUrls.RETENTION_RATE].join('/'),
    DASHBOARD_LTV: [DashboardModuleUrls.DASHBOARD, DashboardModuleUrls.LTV].join('/'),
    WHITE_LABEL: 'wl_domains',
    WHITE_LABEL_USERS: 'wl_domains/:wlDomainIsd/users',
    AD_NETWORK_MONITOR: AppsModuleUrls.AD_NETWORK_MONITOR,
    APPS: AppsModuleUrls.APPS,
    APPS_CREATE: [AppsModuleUrls.APPS, AppsModuleUrls.CREATE].join('/'),
    APPS_UPDATE: [AppsModuleUrls.APPS, AppsModuleUrls.UPDATE].join('/'),

    AD_UNIT_EDITOR: [AppsModuleUrls.APPS, AppsModuleUrls.AD_UNIT_EDITOR_DEPRECATED_URL].join('/'),
    DCC: [AppsModuleUrls.APPS, AppsModuleUrls.DCC].join('/'),
    DCC_LINE_ITEMS: [AppsModuleUrls.APPS, AppsModuleUrls.DCC, DccModuleUrls.LINE_ITEMS].join('/'),
    DCC_CONFIGURATIONS: [AppsModuleUrls.APPS, AppsModuleUrls.DCC, DccModuleUrls.CONFIGURATIONS].join('/'),
    DCC_CONFIGURATIONS_NEW: [AppsModuleUrls.APPS, AppsModuleUrls.DCC, DccModuleUrls.CONFIGURATIONS, DccModuleUrls.NEW_CONFIGURATION].join(
        '/'
    ),
    DCC_CONFIGURATIONS_EDIT: [AppsModuleUrls.APPS, AppsModuleUrls.DCC, DccModuleUrls.CONFIGURATIONS, DccModuleUrls.EDIT_CONFIGURATION].join(
        '/'
    ),
    DCC_CONFIGURATIONS_COPY: [
        AppsModuleUrls.APPS,
        AppsModuleUrls.DCC,
        DccModuleUrls.CONFIGURATIONS,
        DccModuleUrls.COPY_CONFIGURATIONS,
    ].join('/'),

    DCC_MEDIATION_GROUPS: [AppsModuleUrls.APPS, AppsModuleUrls.DCC, DccModuleUrls.MEDIATION_GROUPS].join('/'),
    DCC_MEDIATION_GROUPS_NEW: [
        AppsModuleUrls.APPS,
        AppsModuleUrls.DCC,
        DccModuleUrls.MEDIATION_GROUPS,
        DccModuleUrls.NEW_MEDIATION_GROUP,
    ].join('/'),
    DCC_MEDIATION_GROUPS_EDIT: [
        AppsModuleUrls.APPS,
        AppsModuleUrls.DCC,
        DccModuleUrls.MEDIATION_GROUPS,
        DccModuleUrls.EDIT_MEDIATION_GROUP,
    ].join('/'),
    DCC_MEDIATION_GROUPS_COPY: [
        AppsModuleUrls.APPS,
        AppsModuleUrls.DCC,
        DccModuleUrls.MEDIATION_GROUPS,
        DccModuleUrls.COPY_MEDIATION_GROUP,
    ].join('/'),

    APP_PLACEMENT: AppsModuleUrls.APP_PLACEMENT,
    APP_PLACEMENT_NEW: [AppsModuleUrls.APP_PLACEMENT, IframePagesModuleUrls.NEW].join('/'),
    APP_PLACEMENT_EDIT: [AppsModuleUrls.APP_PLACEMENT, ':placementId', IframePagesModuleUrls.EDIT].join('/'),
    APP_PLACEMENT_CHANGELOG: [AppsModuleUrls.APP_PLACEMENT, ':placementId', IframePagesModuleUrls.CHANGELOG].join('/'),
    APP_ATTRIBUTION_SETTINGS: [AppsModuleUrls.APPS, AppsModuleUrls.ATTRIBUTION_SETTINGS].join('/'),
    APP_EVENTS: [AppsModuleUrls.APPS, AppsModuleUrls.APP_EVENTS].join('/'),

    // old profile links
    APPS_SHARING: 'v3/profile/sharing',

    // new profile links
    PROFILE: ProfilePagesModuleUrls.PROFILE,
    PROFILE_DASHBOARD_PRESET: [ProfilePagesModuleUrls.PROFILE, 'dashboard-preset'].join('/'),
    PROFILE_EDIT: [ProfilePagesModuleUrls.PROFILE, ProfilePagesModuleUrls.EDIT].join('/'),
    PROFILE_APP_ADS_TXT: [ProfilePagesModuleUrls.PROFILE, ProfilePagesModuleUrls.APP_ADS_TXT].join('/'),
    PROFILE_SHARING: [ProfilePagesModuleUrls.PROFILE, 'sharing'].join('/'),
    PROFILE_SHARING_NEW: [ProfilePagesModuleUrls.PROFILE, 'sharing/new'].join('/'),
    PROFILE_SHARING_EDIT: [ProfilePagesModuleUrls.PROFILE, 'sharing/edit'].join('/'),

    // user profile links
    USER_PROFILE: ProfilePagesModuleUrls.USER_PROFILE,
    USER_PROFILE_ADS_TXT: [ProfilePagesModuleUrls.USER_PROFILE, ProfilePagesModuleUrls.ADS_TXT].join('/'),
    USER_PROFILE_EDIT_ACCOUNT: [ProfilePagesModuleUrls.USER_PROFILE, ProfilePagesModuleUrls.EDIT, ProfilePagesModuleUrls.ACCOUNT].join('/'),
    USER_PROFILE_EDIT_SECURITY: [ProfilePagesModuleUrls.USER_PROFILE, ProfilePagesModuleUrls.EDIT, ProfilePagesModuleUrls.SECURITY].join(
        '/'
    ),
    USER_PROFILE_CREDENTIALS: [
        ProfilePagesModuleUrls.USER_PROFILE,
        ProfilePagesModuleUrls.EDIT,
        ProfilePagesModuleUrls.API_CREDENTIALS,
    ].join('/'),

    // segments links
    SEGMENTS: IframePagesModuleUrls.SEGMENTS,
    SEGMENTS_EDIT: [':segmentId', IframePagesModuleUrls.EDIT].join('/'),
    SEGMENTS_CHANGELOG: [':segmentId', IframePagesModuleUrls.CHANGELOG].join('/'),

    // ad_server links
    AD_SERVER: IframePagesModuleUrls.AD_SERVER,

    OLD_PAYOUTS: 'payouts/reports',
    OLD_PAYOUTS_REQUEST: 'payouts/request_payout',
    PAYOUTS: PayoutsModuleUrls.PAYOUTS,
    PAYOUTS_REPORT: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.REPORTS].join('/'),
    PAYOUTS_REQUEST: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.REQUESTS].join('/'),
    PAYOUTS_REQUEST_NEW: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.REQUESTS, PayoutsModuleUrls.NEW].join('/'),
    PAYOUTS_REQUEST_HISTORY: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.REQUESTS, PayoutsModuleUrls.HISTORY].join('/'),
    PAYOUTS_REQUEST_AUTO_PAYOUTS_SETTINGS: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.REQUESTS, PayoutsModuleUrls.AUTO_PAYOUTS].join(
        '/'
    ),
    PAYOUTS_REQUEST_DOWNLOAD_PDF: 'payouts/:id.pdf',
    PAYOUTS_DETAILS: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.DETAILS].join('/'),
    PAYOUTS_AMBASSADOR_PROGRAM: 'payouts/ambassador-program',
    PAYOUTS_PUBLISHING: [PayoutsModuleUrls.PAYOUTS, PayoutsModuleUrls.PUBLISHING].join('/'),
    PAYOUTS_REPORT_DOWNLOAD_REPORT: 'payouts/reports.pdf?selected_month=:selectedMonthStart',
    PAYOUTS_REPORT_DOWNLOAD_FULL_HISTORY: 'payouts/payouts_report.csv?selected_month=:selectedMonthStart',
    SDK: 'sdk',
    API_INTEGRATION: 'http://wiki.appodeal.com/:language/:pageName',
    FAQ: 'http://faq.appodeal.com',
    CONTACT_US: 'https://appodeal.com/contact/',
    PANEL: 'admin',
    DOCS: 'http://wiki.appodeal.com/:language',
    TWITTER: 'https://twitter.com/AppodealStack',
    LINKEDIN: 'https://www.linkedin.com/company/appodealstack',
    FACEBOOK: 'https://web.facebook.com/AppodealStack',
    BLOG: 'https://explorestack.com/blog/',
    YOUTUBE: 'https://www.youtube.com/channel/UCVY4t0W0CvCJ_CBSvYcasZg',

    BIDON: 'bidon',

    BID_MANAGER: BidManagerModuleUrls.BID_MANAGER,
    BID_MANAGER_CREATIVES: [BidManagerModuleUrls.BID_MANAGER, BidManagerModuleUrls.CREATIVES].join('/'),
    BID_MANAGER_CREATE_CREATIVE: [BidManagerModuleUrls.BID_MANAGER, BidManagerModuleUrls.CREATE_CREATIVE].join('/'),
    BID_MANAGER_EDIT_CREATIVE: [BidManagerModuleUrls.BID_MANAGER, BidManagerModuleUrls.EDIT_CREATIVE].join('/'),
    BID_MANAGER_CREATE_CAMPAIGN: [BidManagerModuleUrls.BID_MANAGER, BidManagerModuleUrls.CREATE_CAMPAIGN].join('/'),
    BID_MANAGER_CAMPAIGNS: [BidManagerModuleUrls.BID_MANAGER, BidManagerModuleUrls.CAMPAIGNS].join('/'),

    APPODEAL_HOMEPAGE: 'https://appodeal.com/?stop&utm_campaign=%5BDES%5D%20Dashboard%20-%20testing&utm_source=dashboard',
    APPODEAL_BLOG: 'https://appodeal.com/blog/?utm_campaign=%5BDES%5D%20Dashboard%20-%20blog&utm_source=dashboard',
    DEFAULT_MAIN_PAGE: 'default-main-page',

    CREATIVE_LIBRARY: CreativeLibraryModuleUrls.CREATIVE_LIBRARY,
    CREATIVE_LIBRARY_UPLOADS: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.UPLOADS].join('/'),
    CREATIVE_LIBRARY_TEST_RESULTS: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.TEST_RESULTS].join('/'),
    CREATIVE_LIBRARY_CREATIVES: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.CREATIVES].join('/'),

    CREATIVE_LIBRARY_TEST_FLOW: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.TEST_FLOW].join('/'),
    CREATIVE_LIBRARY_CREATE_TEST_FLOW: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.CREATE_TEST_FLOW].join('/'),
    CREATIVE_LIBRARY_EDIT_TEST_FLOW: [CreativeLibraryModuleUrls.CREATIVE_LIBRARY, CreativeLibraryModuleUrls.EDIT_TEST_FLOW].join('/'),

    INTEGRATIONS: IntegrationsModuleUrls.INTEGRATIONS,
    INTEGRATIONS_MEDIATION_AD_NETWORKS: [IntegrationsModuleUrls.INTEGRATIONS, IntegrationsModuleUrls.MEDIATION_AD_NETWORKS].join('/'),
    INTEGRATIONS_USER_ACQUISITION: [IntegrationsModuleUrls.INTEGRATIONS, IntegrationsModuleUrls.USER_ACQUISITION].join('/'),
    INTEGRATIONS_BID_MANAGER: [IntegrationsModuleUrls.INTEGRATIONS, IntegrationsModuleUrls.BID_MANAGER].join('/'),

    MEDIATIONS: IntegrationsModuleUrls.MEDIATIONS,

    USER_ACQUISITION_ACCOUNTS_CREATE: [
        IntegrationsModuleUrls.INTEGRATIONS,
        IntegrationsModuleUrls.USER_ACQUISITION,
        UserAcquisitionAccountsUrls.CREATE,
    ].join('/'),
    USER_ACQUISITION_ACCOUNTS_UPDATE: [
        IntegrationsModuleUrls.INTEGRATIONS,
        IntegrationsModuleUrls.USER_ACQUISITION,
        UserAcquisitionAccountsUrls.UPDATE,
    ].join('/'),

    EXPERIMENTS: ExperimentsModuleUrls.EXPERIMENTS,
    EXPERIMENTS_NEW: [ExperimentsModuleUrls.EXPERIMENTS, ExperimentsModuleUrls.NEW].join('/'),
    EXPERIMENTS_INFO: [ExperimentsModuleUrls.EXPERIMENTS, ExperimentsModuleUrls.INFO].join('/'),
    EXPERIMENTS_EDIT: [ExperimentsModuleUrls.EXPERIMENTS, ExperimentsModuleUrls.EDIT].join('/'),
    EXPERIMENTS_COLLECTION: [ExperimentsModuleUrls.EXPERIMENTS, ExperimentsModuleUrls.COLLECTION].join('/'),

    ONBOARDING: OnboardingModuleUrls.ONBOARDING,
    ONBOARDING_APP: [OnboardingModuleUrls.ONBOARDING, OnboardingModuleUrls.APP].join('/'),
    ONBOARDING_MONETIZATION: [OnboardingModuleUrls.ONBOARDING, OnboardingModuleUrls.MONETIZATION_SETUP].join('/'),
    ONBOARDING_PAYMENTS: [OnboardingModuleUrls.ONBOARDING, OnboardingModuleUrls.PAYMENTS].join('/'),

    BIDON_INSTANCES_CREATE: [IntegrationsModuleUrls.MEDIATIONS, IntegrationsModuleUrls.BIDON_INSTANCES, BidonInstanceUrls.CREATE].join('/'),
    BIDON_INSTANCES_UPDATE: [IntegrationsModuleUrls.MEDIATIONS, IntegrationsModuleUrls.BIDON_INSTANCES, BidonInstanceUrls.UPDATE].join('/'),
};

export function path(template: string, ...args) {
    args.reverse();
    return (
        (hasProtocol(template) ? '' : '/') +
        (args.length ? (<string>template).replace(/:\w+/g, match => args.pop() || match) : <string>template)
    );
}

export function urlWithoutParams(url: string): string {
    const position = url.indexOf('?');
    return position === -1 ? url : url.substring(0, position);
}

function hasProtocol(url: string) {
    return /^[a-z0-9]+:\/\//i.test(url);
}
